import { createUseStyles } from 'react-jss'
import { colors } from '#base/js/variables.style'

export const style = {
  svg: {
    display: 'block',
    overflow: 'hidden'
  },
  zoomOut: {
    position: 'absolute',
    top: 10,
    right: 10
  },
  zoomOutButton: {
    fontSize: 14,
    color: 'white',
    backgroundColor: colors.brandDark,
    border: `1px solid ${colors.brandDark}`,
    borderRadius: 4,
    cursor: 'pointer',
    height: 32,
    padding: '6px 10px',
    textDecoration: 'none',
    '&:hover, &:focus': {
      color: colors.brandDark,
      backgroundColor: 'white',
      outline: 'none'
    }
  }
}

export const useStyles = createUseStyles(style)
